
  window.onload = function() {
  jQuery(document).ready(function ($) {
    var hashrate;
    var earned_day = 0;
    var earned_month = 0;
    var earned_year = 0;
    var ele_day = 0;
    var ele_month = 0;
    var ele_year = 0;

    var hashrateApi = new XMLHttpRequest();

    hashrateApi.open("GET", "https://blockchain.info/q/hashrate");
    hashrateApi.send();
    hashrateApi.onload = () => {
      if (hashrateApi.readyState == 4) {
        var ticker = JSON.parse(hashrateApi.responseText);
        var hashrate = ticker

    var append_html = hashrate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    $("#cur_hash_rate").append(append_html);

    $.getJSON("https://api.coinbase.com/v2/prices/spot?currency=USD", function (data) {

      var prices = document.querySelector('.bitcoin-price');
      var b = prices.innerHTML;

      b.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")

      $("#bitcoin_price").val(b);
    });

    function stringToTS(s) {
      var b = s.toString().split(".");
      b[0] = b[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
      var c = b.join('.');
      return c;
    }

    function getValueForYear(v) {
      var t = 0;
      for (var i = 0; i < 12; i++) {
        v *= 0.8732584107;
        t += v;
      }
      return t;
    }

    function getAppendHTML(v1, v2) {
      var append_html = "";
      if (v1 >= v2) {
        $(".negative-earning").attr('class', 'positive-earning');
        append_html += "+$" + stringToTS((v1 - v2).toFixed(2));
      } else {
        $(".positive-earning").attr('class', 'negative-earning');
        append_html += "-$" + stringToTS((v2 - v1).toFixed(2));
      }
      return append_html;
    }

    function setDValue_Style() {
      jQuery("#d_day").html(getAppendHTML(earned_day, ele_day));
      jQuery("#d_month").html(getAppendHTML(earned_month, ele_month));
      jQuery("#d_year").html(getAppendHTML(earned_year, ele_year));
    }

    var eventCalc1Handler = function () {
      var unit = 1;
      var sel_index = document.getElementById("unit_select").selectedIndex;
      if (document.getElementById("unit_select").options[sel_index].value == "t")
        unit = 1000;

      var s = jQuery("#hash_rate").val().toString().replace(/\,/g, '');
      jQuery("#hash_rate").val(stringToTS(s));

      var price = jQuery("#bitcoin_price").val().toString().replace(/\,/g, '');
      jQuery("#bitcoin_price").val(stringToTS(price));

      uhr = s / hashrate * unit;

      if (isNaN(uhr)) {
        jQuery("#user_hash_rate").html("0");
        jQuery("#chance").html("0");
        jQuery("#earned_btc_day").html("0");
        jQuery("#earned_btc_month").html("0");
        jQuery("#earned_dollar_day").html("0");
        jQuery("#earned_dollar_month").html("0");
        earned_day = 0;
        earned_month = 0;
        earned_month = 0;
      } else {
        var q = uhr.toFixed(8);
        jQuery("#user_hash_rate").html(stringToTS(q));

        uhr *= 144;
        jQuery("#chance").html(stringToTS(uhr.toFixed(8)));

        uhr *= 12.5;

        uhr *= 30;

        var uhr = getValueForYear(uhr);
        earned_day = uhr / 365 * price;
        earned_month = uhr / 12 * price;
        earned_year = uhr * price;

        jQuery("#earned_btc_year").html(stringToTS(uhr.toFixed(4)));
        jQuery("#earned_dollar_year").html(stringToTS(earned_year.toFixed(2)));
        jQuery("#earned_btc_day").html(stringToTS((uhr / 365).toFixed(4)));
        jQuery("#earned_dollar_day").html(stringToTS(earned_day.toFixed(2)));
        jQuery("#earned_btc_month").html(stringToTS((uhr / 12).toFixed(4)));
        jQuery("#earned_dollar_month").html(stringToTS(earned_month.toFixed(2)));
      }

      setDValue_Style();
    }

    var eventCalc2Hander = function () {
      var p = jQuery("#power_consumption").val().toString().replace(/\,/g, '');
      jQuery("#power_consumption").val(stringToTS(p));

      var c = jQuery("#cost_kw").val().toString().replace(/\,/g, '');
      jQuery("#cost_kw").val(stringToTS(c));

      var ec = p / 1000 * 24 * c;
      if (isNaN(ec)) {
        jQuery("#ele_costs_day").html("0");
        jQuery("#ele_costs_month").html("0");
        jQuery("#ele_costs_year").html("0");
        ele_day = 0;
        ele_month = 0;
        ele_year = 0;
      } else {
        var q = ec.toFixed(2);
        jQuery("#ele_costs_day").html(stringToTS(q));

        ec *= 30;
        q = ec.toFixed(2);
        jQuery("#ele_costs_month").html(stringToTS(q));

        ec *= 12;
        q = ec.toFixed(2);
        jQuery("#ele_costs_year").html(stringToTS(q));

        ele_year = ec;
        ele_month = ec / 12;
        ele_day = ec / 12 / 30;
      }

      setDValue_Style()
    }

    jQuery("#hash_rate").bind('input', eventCalc1Handler);
    jQuery("#bitcoin_price").bind('input', eventCalc1Handler);
    jQuery("#unit_select").bind('change', eventCalc1Handler);

    jQuery("#power_consumption").bind('input', eventCalc2Hander);
    jQuery("#cost_kw").bind('input', eventCalc2Hander);
        }
      };
  });
}
// }
// }

  // export { miningCalculator };
